<template>
  <div style="width: auto; padding: 40px 0 20px 0">
    <div class="container">
      <div style="width: 49%; height: 100%; position: relative">
        <div class="template">
          <div class="table-container">
            <table
              cellpadding="20"
              style="height: 100%; width: 100%; margin: 0"
            >
              <tr style="height: 20px !important">
                <td :colspan="reportData.secondTerm ? '4' : '5'">
                  科&emsp;&emsp;目
                </td>
                <td :colspan="reportData.secondTerm ? '4' : '5'">
                  平&emsp;&emsp;时
                </td>
                <td :colspan="reportData.secondTerm ? '4' : '5'">
                  期&emsp;&emsp;末
                </td>
                <td :colspan="reportData.secondTerm ? '4' : '5'">
                  综&emsp;&emsp;合
                </td>
                <td v-if="reportData.secondTerm" colspan="4">
                  学&emsp;&emsp;年
                </td>
              </tr>
              <template v-for="(inner, index) in reportData.basicSubjectList">
                <template v-if="inner.name !== '体艺2+1'">
                  <tr
                    v-if="
                      (!inner.secondarySubjects ||
                        inner.secondarySubjects.length === 0) &&
                        (!inner.sportsArtSubjects ||
                          inner.sportsArtSubjects.length === 0)
                    "
                    :key="inner.name + index + 'basicSubjectList'"
                  >
                    <td :colspan="reportData.secondTerm ? '4' : '5'">
                      {{ inner && inner.name }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ inner && inner.normal }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ inner && inner.terminal }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ inner && inner.term }}
                    </td>
                    <td
                      v-if="reportData.secondTerm"
                      colspan="4"
                      class="input-mark"
                    >
                      {{ inner && inner.year }}
                    </td>
                  </tr>
                  <template
                    v-else-if="
                      inner.secondarySubjects &&
                        inner.secondarySubjects.length > 0
                    "
                  >
                    <tr
                      v-for="(secondInner,
                      secondIndex) in inner.secondarySubjects"
                      :key="secondInner.name"
                    >
                      <td
                        v-if="secondIndex === 0"
                        colspan="1"
                        :rowspan="inner.secondarySubjects.length"
                      >
                        {{ inner && inner.name }}
                      </td>
                      <td :colspan="reportData.secondTerm ? '3' : '4'">
                        {{ secondInner.name }}
                      </td>
                      <td
                        :colspan="reportData.secondTerm ? '4' : '5'"
                        class="input-mark"
                      >
                        {{ secondInner && secondInner.normal }}
                      </td>
                      <td
                        :colspan="reportData.secondTerm ? '4' : '5'"
                        class="input-mark"
                      >
                        {{ secondInner && secondInner.terminal }}
                      </td>
                      <td
                        v-if="secondIndex === 0"
                        :colspan="reportData.secondTerm ? '4' : '5'"
                        :rowspan="inner.secondarySubjects.length"
                        class="input-mark"
                      >
                        {{ inner && inner.term }}
                      </td>
                      <td
                        v-if="secondIndex === 0 && reportData.secondTerm"
                        colspan="4"
                        :rowspan="inner.secondarySubjects.length"
                        class="input-mark"
                      >
                        {{ inner && inner.year }}
                      </td>
                    </tr>
                  </template>
                </template>
                <template
                  v-if="
                    inner.name === '体艺2+1' &&
                      inner.sportsArtSubjects &&
                      inner.sportsArtSubjects.length > 0 &&
                      inner.sportsArtSubjects.length <= 3
                  "
                >
                  <tr
                    v-for="(secondInner,
                    secondIndex) in inner.sportsArtSubjects"
                    :key="secondIndex + 'secondIndex-sportsArtSubjects'"
                  >
                    <td v-if="secondIndex === 0" colspan="1" :rowspan="3">
                      {{ inner && inner.name }}
                    </td>
                    <td :colspan="reportData.secondTerm ? '3' : '4'">
                      {{ secondInner.name }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ secondInner && secondInner.normal }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ secondInner && secondInner.terminal }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ secondInner && secondInner.term }}
                    </td>
                    <td
                      v-if="reportData.secondTerm"
                      colspan="4"
                      class="input-mark"
                    >
                      {{ secondInner && secondInner.year }}
                    </td>
                  </tr>
                  <template v-if="inner.sportsArtSubjects.length < 3">
                    <tr
                      v-for="(secondInner, secondIndex) in 3 -
                        inner.sportsArtSubjects.length"
                      :key="
                        (secondInner.name + secondIndex) + '-sportsArtSubjects'
                      "
                    >
                      <td :colspan="reportData.secondTerm ? '3' : '4'">
                        {{ "" }}
                      </td>
                      <td
                        :colspan="reportData.secondTerm ? '4' : '5'"
                        class="input-mark"
                      >
                        {{ "" }}
                      </td>
                      <td
                        :colspan="reportData.secondTerm ? '4' : '5'"
                        class="input-mark"
                      >
                        {{ "" }}
                      </td>
                      <td
                        :colspan="reportData.secondTerm ? '4' : '5'"
                        class="input-mark"
                      >
                        {{ "" }}
                      </td>
                      <td
                        v-if="reportData.secondTerm"
                        colspan="4"
                        class="input-mark"
                      >
                        {{ "" }}
                      </td>
                    </tr>
                  </template>
                </template>
                <template
                  v-if="
                    inner.name === '体艺2+1' &&
                      inner.sportsArtSubjects &&
                      inner.sportsArtSubjects.length > 3
                  "
                >
                  <tr
                    v-for="(emptyInner, emptyIndex) in ['', '', '']"
                    :key="
                      (emptyIndex + index) + 'index-sportsArtSubjects'
                    "
                  >
                    <td v-if="emptyIndex === 0" colspan="1" :rowspan="3">
                      {{ inner && inner.name }}
                    </td>
                    <td :colspan="reportData.secondTerm ? '3' : '4'">
                      {{ inner.sportsArtSubjects[emptyIndex].name }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ inner.sportsArtSubjects[emptyIndex] && inner.sportsArtSubjects[emptyIndex].normal }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ inner.sportsArtSubjects[emptyIndex] && inner.sportsArtSubjects[emptyIndex].terminal }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ inner.sportsArtSubjects[emptyIndex] && inner.sportsArtSubjects[emptyIndex].term }}
                    </td>
                    <td
                      v-if="reportData.secondTerm"
                      colspan="4"
                      class="input-mark"
                    >
                      {{ inner.sportsArtSubjects[emptyIndex] && inner.sportsArtSubjects[emptyIndex].year }}
                    </td>
                  </tr>
                  <template v-if="inner.sportsArtSubjects.length < 3">
                    <tr
                      v-for="(secondInner, secondIndex) in 3 -
                        inner.sportsArtSubjects.length"
                      :key="
                        secondInner.name + secondIndex + '-sportsArtSubjects'
                      "
                    >
                      <td :colspan="reportData.secondTerm ? '3' : '4'">
                        {{ "" }}
                      </td>
                      <td
                        :colspan="reportData.secondTerm ? '4' : '5'"
                        class="input-mark"
                      >
                        {{ "" }}
                      </td>
                      <td
                        :colspan="reportData.secondTerm ? '4' : '5'"
                        class="input-mark"
                      >
                        {{ "" }}
                      </td>
                      <td
                        :colspan="reportData.secondTerm ? '4' : '5'"
                        class="input-mark"
                      >
                        {{ "" }}
                      </td>
                      <td
                        v-if="reportData.secondTerm"
                        colspan="4"
                        class="input-mark"
                      >
                        {{ "" }}
                      </td>
                    </tr>
                  </template>
                </template>
                <template
                  v-if="
                    inner.name === '体艺2+1' &&
                      (!inner.sportsArtSubjects ||
                        inner.sportsArtSubjects.length === 0)
                  "
                >
                  <tr
                    v-for="(secondInnerRest, secondIndexRest) in restArr"
                    :key="
                      'rest' + secondIndexRest + index + '-featureSubjectList'
                    "
                  >
                    <td v-if="secondIndexRest === 0" colspan="1" rowspan="3">
                      {{ inner && inner.name }}
                    </td>
                    <td
                      v-if="secondIndexRest === 0"
                      :colspan="reportData.secondTerm ? '3' : '4'"
                    >
                      {{ !template ? "" : "棋类" }}
                    </td>
                    <td
                      v-if="secondIndexRest === 1"
                      :colspan="reportData.secondTerm ? '3' : '4'"
                    >
                      {{ !template ? "" : "游泳" }}
                    </td>
                    <td
                      v-if="secondIndexRest === 2"
                      :colspan="reportData.secondTerm ? '3' : '4'"
                    >
                      {{ !template ? "" : "啦啦操" }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ !template ? "" : "优秀" }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ !template ? "" : "优秀" }}
                    </td>
                    <td
                      :colspan="reportData.secondTerm ? '4' : '5'"
                      class="input-mark"
                    >
                      {{ !template ? "" : "优秀" }}
                    </td>
                    <td
                      v-if="reportData.secondTerm"
                      colspan="4"
                      class="input-mark"
                    >
                      {{ !template ? "" : "优秀" }}
                    </td>
                  </tr></template
                >
              </template>
              <template
                v-if="
                  reportData.featureSubjectList &&
                    reportData.featureSubjectList.length > 0
                "
              >
                <tr
                  v-for="(inner, index) in ['', '', '']"
                  :key="index + 'featureSubjectList'"
                >
                  <td v-if="index === 0" colspan="1" rowspan="3">校本课程</td>
                  <td :colspan="reportData.secondTerm ? '3' : '4'">
                    {{
                      reportData.featureSubjectList[index] &&
                        reportData.featureSubjectList[index].name
                    }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                        reportData.featureSubjectList[index].normal
                    }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                        reportData.featureSubjectList[index].terminal
                    }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                        reportData.featureSubjectList[index].term
                    }}
                  </td>
                  <td
                    v-if="reportData.secondTerm"
                    colspan="4"
                    class="input-mark"
                  >
                    {{
                      reportData.featureSubjectList[index] &&
                        reportData.featureSubjectList[index].year
                    }}
                  </td>
                </tr>
                <!-- <tr
                  v-for="(item, index) in 3 -
                  reportData.featureSubjectList.length"
                  :key="index + 'rest-featureSubjectList'"
                >
                  <td :colspan="reportData.secondTerm ? '3' : '4'">{{ "" }}</td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    v-if="reportData.secondTerm"
                    colspan="4"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                </tr> -->
              </template>
              <template v-else>
                <tr
                  v-for="(item, index) in ['', '', '']"
                  :key="index + '-rest-featureSubjectList'"
                >
                  <td v-if="index === 0" colspan="1" rowspan="3">校本课程</td>
                  <td :colspan="reportData.secondTerm ? '3' : '4'">{{ "" }}</td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    :colspan="reportData.secondTerm ? '4' : '5'"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                  <td
                    v-if="reportData.secondTerm"
                    colspan="4"
                    class="input-mark"
                  >
                    {{ "" }}
                  </td>
                </tr>
              </template>
              <tr style="height: 35px; max-height: 35px">
                <td colspan="10">学得好的科目</td>
                <td colspan="10">学有进步的科目</td>
              </tr>
              <tr style="height: 35px; max-height: 35px">
                <td colspan="10" class="input-mark"></td>
                <td colspan="10" class="input-mark"></td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div style="width: 49%; height: 100%; position: relative">
        <!-- page2 -->
        <div class="template">
          <div class="table-container">
            <table
              cellpadding="20"
              style="height: 100%; width: 100%; margin: 0"
            >
              <tr style="height: 30px">
                <td colspan="17">品行表现项目</td>
                <td colspan="3">评定</td>
              </tr>
              <template
                v-if="
                  reportData.evalPointList &&
                    reportData.evalPointList.length > 0 &&
                    reportData.evalPointList.length <= 20
                "
              >
                <tr
                  v-for="(item, index) in reportData.evalPointList"
                  :key="'reportData.evalPointList-' + item.content"
                >
                  <td colspan="17" style="text-align: left; padding-left: 5px">
                    <span
                      v-if="
                        reportData.evalPointList[index] &&
                          reportData.evalPointList[index].content
                      "
                      class="eval-list"
                      :style="{
                        lineHeight:
                          (reportData.evalPointList[index] &&
                            reportData.evalPointList[index].content.length >
                              39) ||
                          (reportData.evalPointList[index].content.length ===
                            39 &&
                            !/\s/.test(reportData.evalPointList[index].content))
                            ? '18px'
                            : '36px',
                      }"
                      :title="
                        index +
                          1 +
                          '.' +
                          (reportData.evalPointList[index] &&
                            reportData.evalPointList[index].content)
                      "
                    >
                      <div class="inner-span">
                        {{
                          index +
                            1 +
                            "." +
                            (reportData.evalPointList[index] &&
                              reportData.evalPointList[index].content)
                        }}
                      </div></span
                    >
                  </td>
                  <td colspan="3" class="input-mark">
                    {{
                      reportData.evalPointList[index] &&
                        reportData.evalPointList[index].score
                    }}
                  </td>
                </tr>
              </template>
              <template
                v-else-if="
                  reportData.evalPointList &&
                    reportData.evalPointList.length > 20
                "
              >
                <tr
                  v-for="(item, index) in 20"
                  :key="'reportData.evalPointList-' + index"
                >
                  <td colspan="17" style="text-align: left; padding-left: 5px">
                    <span
                      class="eval-list"
                      :style="{
                        lineHeight:
                          (reportData.evalPointList[index] &&
                            reportData.evalPointList[index].content.length >
                              39) ||
                          (reportData.evalPointList[index].content.length ===
                            39 &&
                            !/\s/.test(reportData.evalPointList[index].content))
                            ? '18px'
                            : '36px',
                      }"
                      :title="
                        index +
                          1 +
                          '.' +
                          (reportData.evalPointList[index] &&
                            reportData.evalPointList[index].content)
                      "
                    >
                      <div class="inner-span">
                        {{
                          index +
                            1 +
                            "." +
                            (reportData.evalPointList[index] &&
                              reportData.evalPointList[index].content)
                        }}
                      </div></span
                    >
                  </td>
                  <td colspan="3" class="input-mark">
                    {{
                      reportData.evalPointList[index] &&
                        reportData.evalPointList[index].score
                    }}
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(item, index) in 10" :key="index + '-evalPointList'">
                  <td colspan="17" style="text-align: left; padding-left: 5px">
                    <span style="font-size: 9px; line-height: 18px">{{
                      index + 1 + "."
                    }}</span>
                  </td>
                  <td colspan="3" class="input-mark">{{ "" }}</td>
                </tr>
              </template>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div style="width: 49%; height: 100%; position: relative">
        <!-- page3 -->
        <div class="template" style="width: 100%">
          <div class="table-container">
            <table
              cellpadding="28"
              style="height: 100%; width: 100%; margin: 0"
            >
              <tr>
                <td colspan="4" rowspan="2">身体状况</td>
                <td colspan="6">身高(cm)</td>
                <td colspan="6">体重(kg)</td>
                <td colspan="2" rowspan="2">视力</td>
                <td colspan="2">左</td>
                <td colspan="8" class="input-mark">
                  {{
                    reportData.physicalVo && reportData.physicalVo.visionLeft
                  }}
                </td>
              </tr>
              <tr>
                <td colspan="6" class="input-mark">
                  {{ reportData.physicalVo && reportData.physicalVo.height }}
                </td>
                <td colspan="6" class="input-mark">
                  {{ reportData.physicalVo && reportData.physicalVo.weight }}
                </td>
                <td colspan="2">右</td>
                <td colspan="8" class="input-mark">
                  {{
                    reportData.physicalVo && reportData.physicalVo.visionRight
                  }}
                </td>
              </tr>
              <tr>
                <td colspan="4" rowspan="6">出勤情况</td>
                <td colspan="6" rowspan="3">
                  本学期共上课
                  <span class="input-mark">{{
                    numberTran(reportData.totalClassDays)
                  }}</span>
                  天
                </td>
                <td colspan="6" rowspan="2">
                  病假
                  <span class="input-mark">{{
                    numberTran(reportData.sickLeaveDays)
                  }}</span>
                  天
                </td>
                <td colspan="12" rowspan="6">
                  <p>
                    新学期开学日期为
                    <span class="input-mark">{{
                      reportData.termBeginMonth
                    }}</span
                    >月
                    <span class="input-mark">{{ reportData.termBeginDay }}</span
                    >日，
                  </p>
                  <p>
                    新学期报到日期为
                    <span class="input-mark">{{
                      reportData.reportDutyMonth
                    }}</span
                    >月
                    <span class="input-mark">{{
                      reportData.reportDutyDay
                    }}</span
                    >日。
                  </p>
                </td>
              </tr>
              <tr></tr>
              <tr>
                <td colspan="6" rowspan="2">
                  事假
                  <span class="input-mark">{{
                    numberTran(reportData.absenceLeaveDays)
                  }}</span>
                  天
                </td>
              </tr>
              <tr>
                <td colspan="6" rowspan="3">
                  实到
                  <span class="input-mark">{{
                    numberTran(reportData.attendClassDays)
                  }}</span>
                  天
                </td>
              </tr>
              <tr>
                <td colspan="6" rowspan="2">
                  旷课
                  <span class="input-mark">{{
                    numberTran(reportData.truancyDays)
                  }}</span>
                  天
                </td>
              </tr>
              <tr></tr>
              <tr style="height: 30px; max-height: 30px">
                <td colspan="4">校长</td>
                <td colspan="6">
                  <span v-if="!reportData.schoolMasterSeal"></span>
                  <img
                    v-else
                    :src="reportData.schoolMasterSeal"
                    style="width: 100%; max-width: 100px"
                    alt="校长印章"
                  />
                </td>
                <td colspan="4">
                  教导
                  <br />
                  <br />
                  <br />主任
                </td>
                <td colspan="6">
                  <span v-if="!reportData.teachingDirectorSeal"></span>
                  <img
                    v-else
                    :src="reportData.teachingDirectorSeal"
                    style="width: 100%; max-width: 100px"
                    alt="教导主任印章"
                  />
                </td>
                <td colspan="2">班主任</td>
                <td colspan="6">
                  <span v-if="!reportData.classTeacherSeal"></span>
                  <img
                    v-else
                    :src="reportData.classTeacherSeal"
                    style="width: 100%; max-width: 100px"
                    alt="班主任印章"
                  />
                </td>
              </tr>
              <tr style="height: 40px; max-height: 40px">
                <td colspan="4">奖惩情况</td>
                <td colspan="16" class="input-mark">
                  {{ reportData.rewardsContent }}
                </td>
                <td colspan="2">操行<br />评定</td>
                <td colspan="6" class="input-mark">
                  {{ reportData.conductRank }}
                </td>
              </tr>
              <tr style="height: 100px; max-height: 100px">
                <td colspan="4">班主任的话</td>
                <td
                  colspan="24"
                  class="input-mark"
                  style="
                    position: relative;
                    text-align: left;
                    padding: 20px;
                    line-height: 15px;
                  "
                >
                  <p>
                    {{ reportData.generalComment }}
                  </p>
                  <p
                    style="position: absolute; bottom: 10px; right: 20px"
                    class="input-mark"
                  >
                    {{
                      reportData.generalCommentVo &&
                        reportData.generalCommentVo.name
                    }}
                  </p>
                </td>
              </tr>
              <tr style="height: 100px; max-height: 100px">
                <td colspan="4">家长对我说</td>
                <td
                  colspan="24"
                  style="
                    position: relative;
                    text-align: left;
                    padding: 20px;
                    line-height: 15px;
                  "
                >
                  <p class="input-mark">
                    {{ reportData.parentComment }}
                  </p>
                  <p style="position: absolute; bottom: 10px; right: 20px">
                    <span
                      style="display: inline-block; margin-right: 35px"
                      class="input-mark"
                      >{{
                        reportData.parentCommentVo &&
                          reportData.parentCommentVo.name
                      }}</span
                    >
                    <span
                      >签名<span class="input-mark">{{
                        reportData.parentCommentVo &&
                        reportData.parentCommentVo.year
                          ? reportData.parentCommentVo &&
                            reportData.parentCommentVo.year
                          : "&emsp;&emsp;&emsp;"
                      }}</span
                      >年<span class="input-mark">{{
                        reportData.parentCommentVo &&
                        reportData.parentCommentVo.month
                          ? reportData.parentCommentVo &&
                            reportData.parentCommentVo.month
                          : "&emsp;&emsp;"
                      }}</span
                      >月<span class="input-mark">{{
                        reportData.parentCommentVo &&
                        reportData.parentCommentVo.day
                          ? reportData.parentCommentVo &&
                            reportData.parentCommentVo.day
                          : "&emsp;&emsp;"
                      }}</span
                      >日</span
                    >
                  </p>
                </td>
              </tr>
              <tr style="height: 100px; max-height: 100px">
                <td colspan="4">我对自己说</td>
                <td
                  colspan="24"
                  style="
                    position: relative;
                    text-align: left;
                    padding: 20px;
                    line-height: 15px;
                  "
                >
                  <p class="input-mark">
                    {{ reportData.studentComment }}
                  </p>
                  <p style="position: absolute; bottom: 10px; right: 20px">
                    <span
                      style="display: inline-block; margin-right: 35px"
                      class="input-mark"
                      >{{
                        reportData.studentCommentVo &&
                          reportData.studentCommentVo.name
                      }}</span
                    >
                    <span
                      >签名<span class="input-mark">{{
                        reportData.studentCommentVo &&
                        reportData.studentCommentVo.year
                          ? reportData.studentCommentVo &&
                            reportData.studentCommentVo.year
                          : "&emsp;&emsp;&emsp;"
                      }}</span
                      >年<span class="input-mark">{{
                        reportData.studentCommentVo &&
                        reportData.studentCommentVo.month
                          ? reportData.studentCommentVo &&
                            reportData.studentCommentVo.month
                          : "&emsp;&emsp;"
                      }}</span
                      >月<span class="input-mark">{{
                        reportData.studentCommentVo &&
                        reportData.studentCommentVo.day
                          ? reportData.studentCommentVo &&
                            reportData.studentCommentVo.day
                          : "&emsp;&emsp;"
                      }}</span
                      >日</span
                    >
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div style="width: 49%; height: 100%; position: relative">
        <!-- page4 -->
        <div class="template" style="width: 100%">
          <div class="cover-title">小学生素质报告单</div>
          <div class="cover-term">
            <span>
              ( {{ reportData.termStartYear }}&nbsp;—&nbsp;{{
                reportData.termEndYear
              }}学年度第{{ reportData.secondTerm ? "二" : "一" }}学期</span
            >)
          </div>
          <div class="info">
            <div style="position: absolute; bottom: 8vh; text-align: center">
              <p style="margin-bottom: 3vh">
                姓名：<span class="name input-mark">{{
                  reportData.studentName
                }}</span>
              </p>
              <p>
                班级：<span class="class-info input-mark">{{
                  reportData.className
                }}</span>
              </p>
            </div>
          </div>
          <div
            class="school-div"
            :style="{
              backgroundImage: 'url(' + reportData.schoolSeal + ')',
            }"
          >
            <span class="school">{{ reportData.schoolName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['reportData', 'template'],

  components: {},

  data () {
    return {
      restArr: ['', '', '']
    }
  },

  watch: {},

  computed: {},

  updated () {},

  mounted () {},

  methods: {
    numberTran (no) {
      return no && (no.toString() ? no : '/')
    }
  }
}
</script>

<style lang="scss" scoped>
.template {
  height: 100%;
  position: absolute;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.18),
    0px 2px 8px 0px rgba(0, 0, 0, 0.18);
}
.title {
  font-size: 25px;
  font-family: monospace;
  font-weight: bold;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #ff0000;
}
.table-container {
  width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;
  justify-content: center;
}
table {
  height: 100%;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;
  font-family: STSongti-SC-Regular, STSongti-SC;
}
table,
tr,
td {
  border: 0.3px solid #ff0000;
  color: #ff0000;
  text-align: center;
  vertical-align: middle;
}
tr {
  height: 31px;
}
td {
  word-wrap: break-word;
  word-break: break-all;
}
.border-none {
  border: 0;
}
.border-none .border-bottom {
  border-bottom: 0.5px solid #ff0000;
}
.border-none .border-bottom-white {
  border-bottom: 1px solid #ff0000;
}
.border-none .border-left {
  border-left: 0.5px solid #ff0000;
}
.border-none-right {
  border-right: 0;
}
.border-none-left {
  border-left: 0;
}
.term {
  height: 20px;
  margin-top: 15px;
  text-align: center;
  color: #ff0000;
}
.desc {
  display: inline-block;
  line-height: 14px;
  padding: 10px 0;
}
.input-mark {
  color: #1b4e81;
}
.cover-title {
  margin-top: 12vh;
  height: 4vh;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ff0000;
  line-height: 40px;
  text-align: center;
}
.cover-term {
  height: 2vh;
  margin-top: 15px;
  text-align: center;
  color: #ff0000;
}
.info {
  font-size: 18px;
  font-weight: 400;
  color: #ff0000;
  height: calc(100% - 18vh - 300px);
  position: relative;
  display: flex;
  justify-content: center;
}
.name {
  display: inline-block;
  text-align: center;
  min-width: 160px;
  line-height: 30px;
  border-bottom: 1px solid #ff0000;
  white-space: nowrap;
}
.class-info {
  display: inline-block;
  text-align: center;
  min-width: 160px;
  line-height: 30px;
  border-bottom: 1px solid #ff0000;
  white-space: nowrap;
}
.school-div {
  text-align: center;
  min-height: 200px;
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.school {
  position: absolute;
  bottom: 0;
  transform: translate(-50%, -20%);
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ff0000;
}
.container {
  box-sizing: border-box;
  width: 29.7cm;
  height: 21cm;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container + .container {
  margin-top: 30px;
}
.eval-list {
  width: 460px;
  height: 36px;
  font-size: 9px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; //多行在这里修改数字即可
  overflow: hidden;
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
}
.inner-span {
}
</style>



// WEBPACK FOOTER //
// src/components/common/PrimaryTemplate.vue